var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',_vm._b({},'section',_vm.$attrs,false),[_c('h3',{staticClass:"font-nunito mb-4 font-weight-semibold"},[_vm._v(_vm._s(_vm.$vuetify.lang.t(_vm.title)))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }